<script lang="ts">
  import { onMount } from "svelte";
  import { NCFields } from "./../../ts/NCFields";
  import { productId } from "./../../ts/Stores";

  let ncfields = NCFields.Instance();

  let ProductId: string;
  productId.subscribe((value) => {
    ProductId = value;
  });

  let attributes;
  onMount(() => {
    ncfields.appendAttributesAndPriceToSection(ProductId, attributes);
  });
</script>

<div class="stack" bind:this={attributes} />
